/* eslint-disable no-unused-expressions */
import { useEffect, useState } from 'react'

const useVariableSizeBox = (defaultWidth, callbacks) => {
	const [size, setSize] = useState(defaultWidth)
	const { desktopS, tablet, mobile } = callbacks

	useEffect(() => {
		const onResize = () => {
			const { innerWidth } = window
			const vw = document.documentElement.clientWidth
			if (innerWidth >= 1440) {
				setSize(defaultWidth)
				return
			}
			if (innerWidth >= 1024) {
				desktopS && setSize(desktopS(vw))
			} else if (innerWidth >= 768) {
				tablet && setSize(tablet(vw))
			} else {
				mobile && setSize(mobile(vw))
			}
		}
		onResize()
		window.addEventListener('resize', onResize)

		return () => {
			window.removeEventListener('resize', onResize)
		}
	}, [defaultWidth, desktopS, mobile, tablet])

	return size
}

export default useVariableSizeBox
